import { App } from '@components/App/App';
import { createBrowserRouter } from 'react-router';

import { AdministrationRoutes } from '@/pages/Administration/routes.config';
import { FarmingRoutes } from '@/pages/Farming/routes.config';
import { PageError } from '@/pages/PageError/PageError';
import { PathologyRoutes } from '@/pages/Pathology/routes.config';
import { PharmacyRoutes } from '@/pages/Pharmacy/routes.config';
import { ReportRoutes } from '@/pages/Report/routes.config';
import { VaccinationTabletRoutes } from '@/pages/TaskTablet/routes.config';
import { VaccinationRoutes } from '@/pages/Vaccination/routes.config';
import { detectDevice, DeviceType } from '@/utils/detectedDevice';

const getAppRoutes = (deviceType: DeviceType) => {
  const isTablet = deviceType === 'tablet';
  const commonRoutes = [
    {
      path: '*',
      element: <PageError />,
    },
  ];

  const deviceSpecificRoutes = isTablet
    ? VaccinationTabletRoutes
    : [
        ...VaccinationRoutes,
        ...PharmacyRoutes,
        ...ReportRoutes,
        ...PathologyRoutes,
        ...AdministrationRoutes,
        ...FarmingRoutes,
      ];

  return [...deviceSpecificRoutes, ...commonRoutes];
};

/**
 * Устройство определяется при построении роутера (а не при импорте модуля),
 * и один и тот же результат используется и для набора маршрутов, и для разметки App.
 */
export const createAppRouter = () => {
  const deviceType = detectDevice();

  return createBrowserRouter([
    {
      path: '/',
      element: <App deviceType={deviceType} />,
      errorElement: <PageError isNotFound={false} />,
      children: getAppRoutes(deviceType),
    },
  ]);
};
